export default function TermOfUse() {
	return (
		<iframe
			src="https://www.hemiteams.ai/terms-of-use"
			title="Terms of Use"
			className="w-full h-full aspect-square"
		/>
	);
}
